import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { Row, Col } from 'react-bootstrap';

type IpaAdministrationWizardContractInfoProps = {
    contracts: any;
    register: any;
    setValue: any;
    getValues: any;
    fetchMso: any;
    errors: Record<string, any>;
    risks: Record<string, any>;
    types: Record<string, any>;
    companyCodes: any;
    fetchContracts: any;
    termed: string | undefined;
};

const IpaAdministrationWizardContractInfo = (props: IpaAdministrationWizardContractInfoProps) => {
    return (
        <div className='accordion-content'>
            <Row>
                <Col md={5}>
                    <Row>
                        <Col md={6}>
                            <div>
                                <label className='e-label-select'>Type *</label>
                                <DropDownListComponent
                                    id='type'
                                    dataSource={props?.types}
                                    placeholder='Select a type'
                                    {...props?.register('type', { required: 'Type is required' })}
                                    change={({ value }) => {
                                        props?.setValue('type', value);
                                    }}
                                    popupHeight='220px'
                                />
                            </div>
                            {props?.errors?.type && <p className='error-form'>{props.errors.type.message}</p>}
                        </Col>
                        <Col md={6}>
                            <div>
                                <label className='e-label-select'>Contract Type *</label>
                                <DropDownListComponent
                                    id='risk'
                                    dataSource={props?.risks}
                                    value={props?.getValues().risk}
                                    placeholder='Select a Contract Type'
                                    fields={{ text: 'text', value: 'id' }}
                                    change={({ itemData }) => props?.setValue('risk', itemData.id)}
                                    popupHeight='220px'
                                    {...props?.register('risk', { required: 'Contract Type is required' })}
                                />
                            </div>
                            {props?.errors?.risk && <span className='error-form'>{props.errors.risk.message}</span>}
                        </Col>
                    </Row>
                </Col>

                <Col md={7}>
                    <Row>
                        <Col md={7}>
                            <label className='e-label-select'>Contract Name *</label>
                            <DropDownListComponent
                                id='contractName'
                                {...props?.register('contractName', {
                                    required: 'Contract Name is required',
                                })}
                                dataSource={props?.contracts}
                                placeholder='Select a Contract Name'
                                value={props?.getValues().contractName}
                                change={({ itemData, value }) => {
                                    props?.setValue('contractLevelId', Number(itemData.id));
                                    props?.setValue('contractName', value);
                                    props?.fetchMso(itemData.id);
                                }}
                                popupHeight='220px'
                                allowFiltering
                            />
                            {props?.termed === 'Y' && <span className='error-form'>The contract is termed</span>}
                            {props?.errors?.contractName && (
                                <p className='error-form'>{props.errors.contractName.message}</p>
                            )}
                        </Col>
                        <Col md={5}>
                            <Row>
                                <Col md={12}>
                                    <div className={`e-float-input e-input-group e-input-group-margin`}>
                                        <input
                                            type='text'
                                            {...props?.register('facetsCode', {
                                                required: 'Facets Code is required',
                                                maxLength: {
                                                    value: 4,
                                                    message: 'Facets Code can not be more than 4 digits.',
                                                },
                                            })}
                                            placeholder='Facets Code'
                                        />
                                        <span className='e-float-line'></span>
                                        <label className='e-float-text'>Facets Code *</label>
                                    </div>
                                    {props?.errors?.facetsCode && (
                                        <p className='error-form'>{props.errors.facetsCode.message}</p>
                                    )}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

export default IpaAdministrationWizardContractInfo;
